import React from 'react';

import {Card} from '../global/Card';

export const Benefits = (props) => {
  const data = props.data || {};

  return (
    <section className="pt-lg-16 pb-lg-14 pt-md-11 pb-md-16 pb-lg-21  pt-9 pb-11">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-10 col-lg-8 col-xl-6">
            <div className="mb-4 mb-md-6 d-flex">
              <span className="zg-label bg-purple me-2" >{data.number}</span>
              <span className="zg-label bg-purple" >{data.subtitle}</span>
            </div>
            <h2 className="h3 mb-8 mb-md-9 mb-lg-11">
              {data.title}
            </h2>
          </div>
        </div>

        {data.items && data.items.length > 0 && (
          <div className="zg-items-grid zg-items-grid--no-scroll">
            {
              data.items.map((item, index) => (
                <Card
                  key={index}
                  classes={`h-100 ${item.class}`}
                  label={`0${index+1}`}
                  color={item.color}
                  title={item.title}
                  text={item.text}
                  button={item.button}
                />
              ))
            }
          </div>
        )}

      </div>
    </section>
  )
}
